/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectInformationResourceOptions
 */
export interface ProjectInformationResourceOptions {
    /**
     * 
     * @type {string}
     * @memberof ProjectInformationResourceOptions
     */
    canCloseProject: ProjectInformationResourceOptionsCanCloseProjectEnum;
}


/**
 * @export
 */
export const ProjectInformationResourceOptionsCanCloseProjectEnum = {
    CanClose: 'CAN_CLOSE',
    RequireAmendmentValidation: 'REQUIRE_AMENDMENT_VALIDATION',
    OtherUnmetRequirement: 'OTHER_UNMET_REQUIREMENT'
} as const;
export type ProjectInformationResourceOptionsCanCloseProjectEnum = typeof ProjectInformationResourceOptionsCanCloseProjectEnum[keyof typeof ProjectInformationResourceOptionsCanCloseProjectEnum];


/**
 * Check if a given object implements the ProjectInformationResourceOptions interface.
 */
export function instanceOfProjectInformationResourceOptions(value: object): value is ProjectInformationResourceOptions {
    if (!('canCloseProject' in value) || value['canCloseProject'] === undefined) return false;
    return true;
}

export function ProjectInformationResourceOptionsFromJSON(json: any): ProjectInformationResourceOptions {
    return ProjectInformationResourceOptionsFromJSONTyped(json, false);
}

export function ProjectInformationResourceOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectInformationResourceOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'canCloseProject': json['canCloseProject'],
    };
}

export function ProjectInformationResourceOptionsToJSON(value?: ProjectInformationResourceOptions | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'canCloseProject': value['canCloseProject'],
    };
}

